import React from 'react'
import { Row } from 'reactstrap'

const Circle = props => {
  if (props.item.step < props.actual || props.actual === 9) {
    return <i className="ri-checkbox-circle-fill ri-xl text-success" />
  }

  if (props.item.step === props.actual) {
    return <i className="ri-checkbox-blank-circle-line ri-xl text-success" />
  }

  return <i className="ri-checkbox-blank-circle-line ri-xl" style={{ color: '#adb5bd' }} />
}

const HorizontalLineLeft = props => (
  <div
    className="d-flex flex-grow-1"
    style={{
      height: 2,
      backgroundColor:
        props.item.step === 1
          ? 'transparent'
          : props.item.step <= props.actual
            ? '#339933'
            : '#ced4da',
    }}
  />
)

const HorizontalLineRight = props => (
  <div
    className="d-flex flex-grow-1"
    style={{
      height: 2,
      backgroundColor:
        props.item.step === 9
          ? 'transparent'
          : props.item.step < props.actual
            ? '#339933'
            : '#ced4da',
    }}
  />
)

const Label = props => (
  <span
    style={{
      fontSize: 12,
      width: 100,
      textAlign: 'center',
      fontWeight: props.item.step === props.actual ? '600' : 'normal',
      color: props.item.step <= props.actual ? '#339933' : '#adb5bd',
    }}
  >
    {props.item.label}
  </span>
)

const Step = props => (
  <div className="d-flex flex-column flex-grow-1 align-items-center">
    <div
      style={{ width: '100%', height: 30 }}
      className="d-flex flex-row align-items-center"
    >
      <HorizontalLineLeft {...props} />
      <Circle {...props} />
      <HorizontalLineRight {...props} />
    </div>
    <Label {...props} />
  </div>
)

export default props => (
  <>
    <Row style={{ marginLeft: 1, marginRight: 0 }}>
      <Step item={{ step: 1, label: 'Cadastrado' }} {...props} />
      <Step item={{ step: 2, label: 'Elaborando' }} {...props} />
      <Step item={{ step: 3, label: 'Entrega interna' }} {...props} />
      <Step item={{ step: 4, label: 'Compliance' }} {...props} />
      <Step item={{ step: 5, label: 'Aprovação Gestão' }} {...props} />
      <Step item={{ step: 6, label: 'Entrega cliente' }} {...props} />
      <Step item={{ step: 7, label: 'Aprovação cliente' }} {...props} />
      <Step item={{ step: 8, label: 'Faturamento' }} {...props} />
      <Step item={{ step: 9, label: 'Pagamento' }} {...props} />
    </Row>
  </>
)
